import { Component, Input } from '@angular/core';

import { RatingSizeEnum } from './enums/RatingSize.enum';

@Component({
  selector: 'app-vtmn-rating',
  templateUrl: './vtmn-rating.component.html',
  styleUrls: ['./vtmn-rating.component.scss'],
})
export class VtmnRatingComponent {
  @Input() public comments: string;
  @Input() public compact: boolean;
  @Input() public emphasis: number;
  @Input() public maxValue = true;
  @Input() public showValue: boolean;
  @Input() public size = RatingSizeEnum.MEDIUM;
  @Input() public value: number;

  public get compactIconClass(): string {
    if (!this.value) {
      return 'vtmx-star-line';
    }

    if (this.value >= 2.5) {
      return 'vtmx-star-fill';
    }

    return 'vtmx-star-half-fill';
  }

  public get iconClasses(): string[] {
    // Create an array with only empty stars //
    const icons = Array(5).fill('vtmx-star-line');

    // Display empty stars for 0 undefined value //
    if (!this.value) {
      return icons;
    }

    // Display filled stars for value equal or superior to 5 //
    if (this.value >= 5) {
      return icons.fill('vtmx-star-fill');
    }

    // Get the number of filled stars //
    const integer = Math.trunc(this.value);
    // Get the decimal value to get empty/half-fill/fill star //
    const decimal = this.value % 1;

    for (let i = 0; i < integer; i++) {
      icons[i] = 'vtmx-star-fill';
    }

    // If decimal & decimal greater than 0, push half-fill star
    if (decimal !== 0) {
      icons[integer] = 'vtmx-star-half-fill';
    }

    return icons;
  }

  public get ratingSizeClass(): string {
    return `vtmn-rating_size--${this.size}`;
  }
}
